<template>
    <div class="card" @click="$emit('selected', {id, title, body})">
        <div class="card-image">
            <figure class="image is-4by3">
                <img src="https://bulma.io/images/placeholders/1280x960.png" alt="Placeholder image">
            </figure>
        </div>
        <div class="card-content">
            <div class="content is-capitalized">
                {{ title }}
                <b-taglist>
                    <b-tag v-if="tags.includes(1)" type="is-primary" style="color: white">Ágape</b-tag>
                    <b-tag v-if="tags.includes(2)" type="is-secondary">Aviso</b-tag>
                    <b-tag v-if="tags.includes(3)" type="is-success">Evento</b-tag>
                </b-taglist>
            </div>
            <hr>
            <div v-if="shorted">
                {{ body }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlogCard',
    props: ['id', 'title', 'body', 'tags', 'shorted']
}
</script>

<style>
    .card {
        box-shadow: none;
        background-color: #F2F2F2;
    }
</style>